import "@/components/Charts/charts.scss";
import Charts from "./Charts";
import ReportChips from "kinnect-general/reports/ReportChips";
import ReportFilters from "kinnect-general/reports/ReportFilters";
import ReportHeader from "kinnect-general/reports/ReportHeader";
import { FetchesData, Reportable } from "kinnect-mixins";
import { KAutocomplete, KDatePicker, KSelect } from "kinnect-general";
import { VCard, VCardText } from "vuetify/lib";
import { YardDriverReport } from "kinnect-models";
import { sortByKey } from "kinnect-helpers";

export default {
	name: "DriversReport",

	mixins: [
		FetchesData,
		Reportable
	],

	data: vm => ( {
		tempDriverType: vm.$route.query.driverType
			? vm.$route.query.driverType
			: "all",
		driverReports: [],
		driverTypes: [
			{
				text: "Temp and Non-Temp",
				value: "all"
			},
			{
				text: "Only Temp",
				value: "temp"
			},
			{
				text: "Only Non-Temp",
				value: "non-temp"
			}
		]
	} ),

	computed: {
		driverType: {
			get() {
				return this.$route.query.driverType ? this.$route.query.driverType : "all";
			},
			set( driverType ) {
				const query = Object.assign( {}, this.$route.query, { driverType } );

				if ( !driverType || driverType === "all" ) {
					delete query.driverType;
				}

				this.$router.replace( { query } );
			}
		},

		driver: {
			get() {
				return this.$route.query.driver ? parseInt( this.$route.query.driver ) : "all";
			},
			set( driver ) {
				const query = Object.assign( {}, this.$route.query, { driver } );

				if ( !driver || driver === "all" ) {
					delete query.driver;
				}

				this.$router.replace( { query } );
			}
		},

		filteredDriverReports() {
			return this.driverReports.filter( report =>
				this.driverTemporaryFilter( report.driver )
			);
		},

		filteredReports() {
			return this.driverReports.filter( report =>
				this.reportTemporaryFilter( report.driver )
			);
		},

		selectableDrivers() {
			const items = [
				{
					text: "All",
					value: "all"
				}
			];

			const reportItems = this.filteredDriverReports.map( report => ( {
				text: report.driver.user.name,
				value: report.driver.id
			} ) );
			const sortedReportItems = sortByKey( reportItems, "text" );

			items.push( ...sortedReportItems );

			return items;
		},

		selectedDriverReport() {
			if ( this.driver && this.driver !== "all" ) {
				return this.driverReports.find( report => report.driver.id === this.driver );
			}
		},

		selectedDriverName() {
			if ( this.driver === "all" ) {
				const item = this.selectableDrivers.find( driver => driver.value === "all" );

				return item.text;
			}

			if ( this.selectedDriverReport ) {
				return this.selectedDriverReport.driver.user.name;
			}

			return null;
		},

		selectedDriverType() {
			let selected = this.driverTypes.find( type => type.value === "all" );

			if ( this.driverType ) {
				const driverType = this.driverTypes.find( type => type.value === this.driverType );

				if ( driverType ) {
					selected = driverType.text;
				}
			}

			return selected;
		}
	},

	methods: {
		saveReportFilters( props ) {
			const initialStartDate = this.startDate;
			const initialEndDate = this.endDate;

			this.driver = props.driver;
			this.driverType = props.driverType;
			this.startDate = props.startDate;
			this.endDate = props.endDate;

			if ( this.startDate !== initialStartDate
				|| this.endDate !== initialEndDate
			) {
				this.fetchReport();
			}
		},

		reportTemporaryFilter( driver ) {
			if ( this.driverType === "all" ) {
				return true;
			} else if ( this.driverType === "temp" ) {
				return driver.temporary;
			} else if ( this.driverType === "non-temp" ) {
				return !driver.temporary;
			}

			return true;
		},

		driverTemporaryFilter( driver ) {
			if ( this.tempDriverType === "all" ) {
				return true;
			} else if ( this.tempDriverType === "temp" ) {
				return driver.temporary;
			} else if ( this.tempDriverType === "non-temp" ) {
				return !driver.temporary;
			}

			return true;
		},

		async fetchReport() {
			this.driverReports = await YardDriverReport.params( {
				startDate: this.startDate,
				endDate: this.endDate
			} ).get();
		},

		async fetch() {
			await this.fetchReport();
		}
	},

	render() {
		return <VCard loading={this.$wait.is( "get driver reports" ) ? "link" : false}>
			<ReportHeader>
				<ReportFilters
					filters={[
						{
							key: "driver",
							value: this.driver
						},
						{
							key: "driverType",
							value: this.driverType
						},
						{
							key: "startDate",
							value: this.startDate
						},
						{
							key: "endDate",
							value: this.endDate
						}
					]}
					onSave={this.saveReportFilters}
					scopedSlots={{
						"filter.driver": props =>
							<KAutocomplete
								items={this.selectableDrivers}
								label="Driver*"
								prependIcon="person"
								vModel={props.model}
							></KAutocomplete>,

						"filter.driverType": props => {
							this.tempDriverType = props.model;

							return <KSelect
								items={this.driverTypes}
								label="Driver Type*"
								prependIcon="person"
								vModel={props.model}
							></KSelect>;
						},

						"filter.startDate": props =>
							<KDatePicker
								textFieldProps={{
									label: "Start Date*",
									required: true
								}}
								vModel={props.model}
							></KDatePicker>,

						"filter.endDate": props =>
							<KDatePicker
								textFieldProps={{
									label: "End Date*",
									required: true
								}}
								vModel={props.model}
							></KDatePicker>
					}}
				></ReportFilters>

				<ReportChips
					cols={12}
					sm="auto"
					filters={[
						{
							name: "Driver",
							value: this.selectedDriverName
						},
						{
							name: "Driver Type",
							value: this.selectedDriverType
						},
						{
							name: "Start Date",
							value: this.startDate
						},
						{
							name: "End Date",
							value: this.endDate
						}
					]}
				></ReportChips>
			</ReportHeader>

			<VCardText>
				<Charts
					item={this.selectedDriverReport}
					items={this.filteredReports}
				></Charts>
			</VCardText>
		</VCard>;
	}
};
